import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { httpActions, apiActions } from '..';
import {
  REQUEST,
  SHORT_NAME_MINIMUM_CHARACTER,
  ERROR_MESSAGES,
} from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { clearShortNameValidity } from '../actionCreators/apiActions';

const checkFrpShortName = (frpShortName: string) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
) => {
  const resourceName = REQUEST.CHECK_FRP_SHORT_NAME;
  try {
    if (frpShortName.length < SHORT_NAME_MINIMUM_CHARACTER) {
      dispatch(apiActions.clearShortNameValidity());
      return;
    }
    dispatch(httpActions.httpRequestMade(resourceName));
    const response = await makeRequest(
      `${config.frpAPI}/suggest?preferredName=${frpShortName}`,
      {
        credentials: 'same-origin',
        timeoutInMs: config.shortNameFrpAPITimeoutInMs,
      },
    );
    if (response && !response.ok) {
      throw new Error(ERROR_MESSAGES.CHECK_FRP_SHORT_NAME);
    }
    const { Names } = await response.json();
    const isAvailable = Names.indexOf(frpShortName) > -1;
    dispatch(apiActions.isShortNameValid(isAvailable));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    dispatch(clearShortNameValidity());
  }
};

export default checkFrpShortName;
